import { useWSEventsWorker } from '@/workers/ws-events';
import { useHelpers } from './use-helpers';

export const useWorkers = () => {
  const { initializeWSEventsWorker, cleanUpWorker } = useWSEventsWorker();
  const {
    getToken,
    humanInTheLoopURL,
    hitlApiURL,
    serviceDiscoveryURL,
    emBusUrl,
    libraryAccountId,
    mediaURL,
  } = useHelpers();

  const initializeWorkers = (options: {
    isDebug?: boolean;
    isWSDebug?: boolean;
  } = {}) => {
    initializeWSEventsWorker({
      isDebug: options.isDebug,
      isWSDebug: options.isWSDebug,
      token: getToken(),
      serviceDiscoveryURL: serviceDiscoveryURL.value,
      humanInTheLoopURL: humanInTheLoopURL.value,
      humanInTheLoopApiURL: hitlApiURL.value,
      emBusURL: emBusUrl.value,
      libraryRootPath: mediaURL.value,
      libraryAccountId: libraryAccountId.value,
    });
  };

  const cleanUpWorkers = () => cleanUpWorker();
  return { initializeWorkers, cleanUpWorkers };
};
